"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const ItemDefinition_1 = require("./ItemDefinition");
const zod_1 = require("zod");
const FileUploadV2_1 = require("./FileUploadV2");
const configSchema = zod_1.z.object({});
const dataSchema = zod_1.z
    .object({
    svgPaths: zod_1.z.array(zod_1.z.string()),
    // URLs and persisted file data are not always present until Quest submitted.
    signedSvgUrl: zod_1.z.optional(zod_1.z.string()),
    signedUrl: zod_1.z.optional(zod_1.z.string()),
})
    .extend(FileUploadV2_1.PersistedFileSchema.pick({
    identifier: true,
    originalBasename: true,
}).partial().shape);
exports.default = new ItemDefinition_1.ItemDefinition("Signature", configSchema, dataSchema, new validation_1.ValidatorPipeline("Signature Config Validator", []), new validation_1.ValidatorPipeline("Signature Data Validator", [
    new validation_1.Validator("Signature path checker", (item) => {
        const pathCount = item.data.svgPaths?.length ?? 0;
        if (!item.required && pathCount === 0) {
            // TODO: Make sure required is provided or we have a way of
            //  communicating that a validation error is acceptable if not a
            //  required item vs the item is invalid even if not required.
            // not required and user did not fill out signature
            return [];
        }
        else if (pathCount > 0) {
            const paths = parsePaths(item.data.svgPaths);
            const totalLength = getLengthOfAllPaths(paths);
            return totalLength > 200
                ? []
                : [
                    {
                        errorCode: "PATH_LENGTH",
                        message: "Provided signature does not meet requirements. Please try again.",
                        path: ["data", "svgPaths"],
                    },
                ];
        }
        return [
            {
                errorCode: "NO_SIGNATURE",
                message: "Please provide a valid signature.",
                path: ["data", "svgPaths"],
            },
        ];
    }),
]));
function getLengthOfAllPaths(paths) {
    return paths
        .map(getLengthOfPath)
        .reduce((totalLength, length) => totalLength + length, 0);
}
function getLengthOfPath(path) {
    return path.reduce((totalLength, point, index) => {
        if (index > 0) {
            const lastPoint = path[index - 1];
            // d = sqrt( (x2 - x1)^2 + (y2 - y1)^2 )
            const distance = Math.sqrt(Math.pow(point[0] - lastPoint[0], 2) +
                Math.pow(point[1] - lastPoint[1], 2));
            return totalLength + distance;
        }
        return totalLength;
    }, 0);
}
function parsePaths(svgPaths) {
    const stringPaths = [];
    svgPaths.forEach((svgPathString) => {
        // collect all the paths, including subpaths within a path.
        svgPathString.split("M").forEach((path) => {
            if (path.length > 0) {
                stringPaths.push("M" + path);
            }
        });
    });
    return stringPaths.map((svgPathString) => svgPathString
        .split(" ")
        .filter((p) => p !== "M" && p !== "L")
        .map((point) => point.split(",").map((p) => parseInt(p)))
        .filter((p) => p.length === 2 && !isNaN(p[0]) && !isNaN(p[1])));
}
//# sourceMappingURL=Signature.js.map